import intercom from './intercom';
import segment from './segment';

function installRouterPlugins(router) {
  intercom(router);
  segment(router);
}

export default installRouterPlugins;
